export var Network;
(function (Network) {
    Network["Arbitrum"] = "arbitrum";
    Network["Optimism"] = "optimism";
})(Network || (Network = {}));
//# sourceMappingURL=network.js.map